import HomePage from './HomePage';
export default {
    path: '/',
    component: HomePage,
};
